<template>
<v-card>
  <v-card-title class='subtitle-1 overline' >
    Delete this appointment and other appointments in the series
  </v-card-title>
  <v-card-text v-if='!successfullyDeleted' >
    <v-switch persistent-hint
      v-model='futureOnly'
      label='Only delete this appointment and appointments that start after it'
      :hint='deleteHintText' >
    </v-switch>
  </v-card-text>
  <v-card-text v-else >
    <blockquote class='blockquote' >
      Appointments successfully deleted
      <v-btn to='/calendar' outlined outline color='primary' >
        Return to calendar
      </v-btn>
      <!-- <v-list v-if='deleteResult && deleteResult.results' dense subheader >
        <v-subheader class='overline' >
          The following appintments have been deleted:
        </v-subheader>
        <template v-for='appointment in deleteResult.results' >
          <appointment-list-item
            :value='appointment' >
          </appointment-list-item>
        </template>
      </v-list> -->
    </blockquote>
  </v-card-text>
  <v-card-actions >
    <v-btn text flat @click='$emit("close")' >
      Cancel
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn :disabled='successfullyDeleted' :loading='loading' color='error' @click='performDelete' >
      Delete appointments
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
// import AppointmentListItem from '@/components/appointment/AppointmentListItem'

export default {
  name: 'DeleteRecurringAppointment',
  // components: {AppointmentListItem},
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      successfullyDeleted: false,
      appointment: {},
      futureOnly: true,
      loading: false,
      deleteResult: {}
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.appointment = this.value }
      }
    }
  },
  methods: {
    performDelete () {
      this.loading = true
      let params = { future_only: this.futureOnly }
      this.performAction(
        this.$appointmentguru,
        'practitioner',
        'appointments',
        this.appointment.id,
        'delete_recurring',
        params
      ).then((res) => {
        this.loading = false
        this.deleteResult = res.data
        this.successfullyDeleted = true
      }).catch(() => {
        window.alert('An error occurred when trying to delete appointments')
        this.loading = false
      })
    }
  },
  computed: {
    deleteHintText () {
      if (this.futureOnly) {
        return 'Will delete this appointment and any appointments that start after it in the series'
      } else {
        return 'Will delete all appointments in the series'
      }
    }
  },
  i18n: {
    messages: {
      en: {},
      es: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// DeleteRecurringAppointmentForm.vue?3220538c